export const isCustomer = (role) => (role || '').toLowerCase() === 'customer';
export const isAgent = (role) => (role || '').toLowerCase() === 'agent';
export const isTeamLead = (role) => {
  const r = (role || '').toLowerCase();
  return r === 'team_lead' || r === 'team-lead' || r === 'team lead';
};
export const isAdmin = (role) => (role || '').toLowerCase() === 'admin';

